import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cd81c4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Associations")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Associations between  ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  and")

import { ref, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import AppSelectSingle from "@/components/AppSelectSingle.vue";
import { Option, Options } from "@/components/AppSelectSingle";
import AppTabs from "@/components/AppTabs.vue";
import AppNodeBadge from "@/components/AppNodeBadge.vue";
import { Node } from "@/api/node-lookup";
import { getAssociationLabel } from "@/api/categories";
import { Association } from "@/api/node-associations";
import AssociationsSummary from "./AssociationsSummary.vue";
import AssociationsTable from "./AssociationsTable.vue";
import EvidenceViewer from "./EvidenceViewer.vue";

/** route info */
interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionAssociations',
  props: {
    node: null
  },
  setup(__props: any) {

const props = __props as {
  /** current node */
  node: Node;
}

const router = useRouter();
const route = useRoute();



/** mode tabs */
const tabs = [
  {
    id: "summary",
    text: "Summary",
    icon: "clipboard",
    tooltip: "Top few associations and high level details",
  },
  {
    id: "table",
    text: "Table",
    icon: "table",
    tooltip: "All association data, in tabular form",
  },
];
const tab = ref(tabs[0].id);

/** selected category of associations to show */
const category = ref<Option>();
/** selected association id */
const association = ref<Association>();

/** list of options for dropdown */
const categoryOptions = computed(
  (): Options =>
    props.node.associationCounts.map((association) => ({
      id: association.id,
      name: getAssociationLabel(association.id),
      icon: `category-${association.id}`,
      count: association.count,
    }))
);

/** deselect association when selected category changes */
watch(category, () => (association.value = undefined));

/** update url from selected category */
watch(
  category,
  () => {
    router.replace({
      ...route,
      query: { associations: category.value?.id },
    });
  },
  /** avoid extra triggering of watch functions */
  { flush: "post" }
);

/** update selected category from url */
watch(
  () => route.query.associations,
  () => {
    if (route.query.associations)
      category.value = categoryOptions.value.find(
        (option) => option.id === route.query.associations
      );
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, { icon: "arrows-left-right" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_AppFlex, { gap: "small" }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _hoisted_2,
              _createVNode(AppNodeBadge, {
                node: __props.node,
                link: false
              }, null, 8, ["node"]),
              _hoisted_3
            ]),
            _createVNode(AppSelectSingle, {
              modelValue: category.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event)),
              name: "category",
              options: _unref(categoryOptions)
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        (category.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(AppTabs, {
                modelValue: tab.value,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (association.value = undefined))
                ],
                tabs: tabs,
                name: "Association viewing mode",
                url: false
              }, null, 8, ["modelValue"]),
              (tab.value === 'summary')
                ? (_openBlock(), _createBlock(AssociationsSummary, {
                    key: 0,
                    node: __props.node,
                    "selected-category": category.value.id,
                    "selected-association": association.value,
                    onSelect: _cache[3] || (_cache[3] = (value) => (association.value = value))
                  }, null, 8, ["node", "selected-category", "selected-association"]))
                : _createCommentVNode("", true),
              (tab.value === 'table')
                ? (_openBlock(), _createBlock(AssociationsTable, {
                    key: 1,
                    node: __props.node,
                    "selected-category": category.value.id,
                    "selected-association": association.value,
                    onSelect: _cache[4] || (_cache[4] = (value) => (association.value = value))
                  }, null, 8, ["node", "selected-category", "selected-association"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (association.value)
      ? (_openBlock(), _createBlock(EvidenceViewer, {
          key: 0,
          node: __props.node,
          "selected-association": association.value
        }, null, 8, ["node", "selected-association"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})